import { render, staticRenderFns } from "./imgCollection.vue?vue&type=template&id=0c4dfcdc&"
import script from "@viewJs/excuseExam/imgCollection.js?vue&type=script&lang=js&"
export * from "@viewJs/excuseExam/imgCollection.js?vue&type=script&lang=js&"
import style0 from "./imgCollection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports